import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom'
import { Upload, message, Row, Col, Form, Button, Switch, Input, Select, Checkbox, Pagination } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import GenericProductItem from '@components/GenericProductItem';
import SimpleImageEditor from '@components/SimpleImageEditor';
import BrandSelect from '@components/BrandSelect';
import MerchantSelect from '@components/MerchantSelect';
import CategorySelect from '@components/CategorySelect';
import { imageSearch, getP13nSearchWithProductId, getP13nSearchWithImageUrl } from '@services/imageSearch';
import { discoverV2, getExtimatedProductPrice, modifyName, modifyCate } from '@services/productService';
import bxlUtils from 'bxl-utils';
import { showError } from '@utils/alert';
import JobExecutor from './jobExecutor';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useParams } from 'react-router-dom'
import { hashcode } from '@utils/index'
import CategoryTreeSelect from "../../containers/CategoryTreeSelect";

const { Dragger } = Upload
const { Option } = Select

const isMobile = bxlUtils.platform.isAndroid() || bxlUtils.platform.isIOS()

const executor = new JobExecutor(4)

const imgSize = (file: any) => {
  return new Promise((resolve, reject) => {
    try {
      const _URL = window.URL || window.webkitURL
      const img = new Image()
      const fileUrl = _URL.createObjectURL(file)
      img.onload = function () {
        resolve({
          width: img.width,
          height: img.height,
        })
      }
      img.src = fileUrl
      setTimeout(() => {
        _URL.revokeObjectURL(fileUrl)
      }, 10)
    } catch (e) {
      console.error(e)
      reject()
    }
  })
}



const ImageSearch = () => {
  const { id }: any = useParams()
  const [form]: [any] = Form.useForm()
  const [modifyForm]: [any] = Form.useForm()
  const [matches, setMatches]: [any, any] = useState(null)
  const [products, setProducts]: [any, any] = useState(null)
  const [currentFile, setCurrentFile]: [any, any] = useState(null)
  const [regions, setRegions] = useState([0, 0, 0, 0])
  const [checkedAll, setCheckedAllChange] = useState(true)
  const [checkedProduct, setCheckedProduct]: [any, any] = useState([])
  const [selectedCategories, setSelectedCategories]: [any, any] = useState([])
  const [total, setTotal]: [any, any] = useState(0)
  const [page, setPage]: [any, any] = useState({
    pageNo: 1,
    pageSize: 20
  })

  useEffect(() => {
    if (products?.length) {
      let _setCheckedProduct = new Array(products.length).fill(true);
      setCheckedProduct([..._setCheckedProduct])
    }
  }, [products])

  const searchProductWithIds = (ids: string[]) => {
    const hide = message.loading('loading')
    const oos = form.getFieldValue('oos')
    discoverV2({
      pid: ids,
      oos: !!oos,
    })
      .then(res => {
        if (Array.isArray(res.data.products)) {
          setProducts(
            [...res.data.products]
              .filter(p => ids.indexOf(p.id) !== -1)
              .sort((a, b) => {
                return ids.indexOf(a.id) - ids.indexOf(b.id)
              })
          )
          const productIds = res.data.products.map(p => p.id).filter(id => ids.indexOf(id) !== -1)
          const finalPrices = {}
          const onFinalPricesCallback = () => {
            if (Object.keys(finalPrices).length !== productIds.length * 2) return
            setProducts(
              [...res.data.products]
                .map(p => {
                  return {
                    ...p,
                    fixedPriceCC: finalPrices?.[p.id + '_cc'],
                    fixedPriceBC: finalPrices?.[p.id + '_bc'],
                  }
                })
                .filter(p => ids.indexOf(p.id) !== -1)
                .sort((a, b) => {
                  return ids.indexOf(a.id) - ids.indexOf(b.id)
                })
            )
          }
          for (let i = 0; i < productIds.length; i++) {
            // CC, BIEYANG
            executor.enqueue(productIds[i] + '_cc', () => {
              return getExtimatedProductPrice(productIds[i], 'BIEYANG').then(({ data }) => {
                // only get first 
                const p = data?.[0] || { status: 'done' }
                finalPrices[productIds[i] + '_cc'] = p
                onFinalPricesCallback()
              }).catch(e => {
                finalPrices[productIds[i] + '_cc'] = { status: 'error' }
                console.error(e)
              })
            })
            // BC, SUNSHINE_CUSTOM
            executor.enqueue(productIds[i] + '_bc', () => {
              return getExtimatedProductPrice(productIds[i], 'SUNSHINE_CUSTOM').then(({ data }) => {
                const p = data?.[0] || { status: 'done' }
                finalPrices[productIds[i] + '_bc'] = p
                onFinalPricesCallback()
              }).catch(e => {
                finalPrices[productIds[i] + '_bc'] = { status: 'error' }
                console.error(e)
              })
            })
          }
        }
        hide()
      })
      .catch(error => {
        hide()
        console.error(error)
      })
  }

  const searchById = (id: string) => {
    return new Promise((resolve, reject) => {
      form.validateFields().then((value: any) => {
        // 后端限制上限为100
        getP13nSearchWithProductId(0, 100, id, value.brandIds, value.categoryIds, value.merchantIds)
          .then(({ data }) => {
            setCurrentFile(null)
            resolve(data)
          })
          .catch(e => reject(e))
      }).catch(e => reject(e))
    })
  }

  const searchByUrl = (url: string) => {
    return new Promise((resolve, reject) => {
      form.validateFields().then((value: any) => {
        // 后端限制上限为100
        getP13nSearchWithImageUrl(0, 100, url, value.brandIds, value.categoryIds, value.merchantIds)
          .then(({ data }) => {
            setCurrentFile(null)
            resolve(data)
          })
          .catch(e => reject(e))
      }).catch(e => reject(e))
    })
  }

  const searchByimage = (file, onProgress?: any) => {
    return new Promise((resolve, reject) => {
      imgSize(file)
        .then((size: any) => {
          let name = file.name
          let extension = ''
          if (file.name && file.name.indexOf('.') !== -1) {
            name = file.name.substring(0, file.name.lastIndexOf('.'))
            extension = file.name.substring(file.name.lastIndexOf('.'))
          }
          form.validateFields().then((value: any) => {
            const formData = new FormData()
            formData.append('file', file, hashcode(name) + extension)
            const onUploadProgress = (total: any, loaded: any) => {
              onProgress && onProgress({ percent: +Math.round((loaded / total) * 100).toFixed(2) }, file)
            }
            // 后端限制上限为100
            imageSearch(0, 100, formData, value.brandIds, value.categoryIds, value.merchantIds, onUploadProgress)
              .then(({ data }) => {
                resolve(data)
              })
              .catch(e => reject(e))
          }).catch(e => reject(e))
        })
        .catch(e => reject(e))
    })
  }

  const uploadReq = ({ file, onError, onSuccess, onProgress }: any) => {
    searchByimage(file, onProgress)
      .then(data => {
        onSuccess(data, file)
      })
      .catch(onError)
    return {
      abort() {
        console.log('upload progress is aborted.')
      },
    }
  }

  const onSearch = () => {
    const type = form.getFieldValue('type')
    let promiseRequest: Promise<any> | null = null
    if (type === 'id') {
      const id = form.getFieldValue('product_id')
      if (!id) {
        message.error('请输入 product id')
        return
      }
      promiseRequest = searchById(id)
    } else if (type === 'url') {
      const url = form.getFieldValue('url')
      if (!url) {
        message.error('请输入 image url')
        return
      }
      promiseRequest = searchByUrl(url)
    } else if (!currentFile) {
      message.error('请先上传图片!')
      return
    } else {
      promiseRequest = searchByimage(currentFile.originFileObj)
    }
    const hide = message.loading('加载中...')
    promiseRequest?.then((res: any) => {
      hide()
      // console.log(res)
      if (!res) return
      if (res.region) {
        setRegions(res.region.split(',').map(n => +n))
      }
      if (Array.isArray(res.matches)) {
        setTotal(res.matches.length)
        setMatches(res.matches)
        const curPageIds = getCurPageIds(res.matches) || []
        searchProductWithIds(curPageIds)
      }
    })
      .catch(e => {
        showError('加载失败', e)
        console.error(e)
        hide()
      })
  }

  // 获取当前页的ID 
  const getCurPageIds = (matches: any) => {
    if (!Array.isArray(matches)) return
    return matches.map(m => m.productId).filter((p, i) => {
      return i >= (page.pageNo-1) * page.pageSize && i < page.pageNo * page.pageSize
    })
  }

  const getCentPriceTag = (cents?: number): string => {
    if (Number.isNaN(cents)) return ''
    return '$' + (cents!! / 100)
  }

  const getFinalPrice = (fixedPrice: any, explanation?: any) => {
    if (explanation && explanation.notApplicableReason) return explanation.notApplicableReason
    let sb = ''
    if (!Number.isNaN(fixedPrice?.fixedPrice)) {
      sb += getCentPriceTag(fixedPrice?.fixedPrice)
    }
    sb += '('
    if (!Number.isNaN(fixedPrice?.forwardingShippingCents)) {
      sb += '运费: ' + getCentPriceTag(fixedPrice?.forwardingShippingCents)
    }
    if (!Number.isNaN(fixedPrice?.dutyCents) && fixedPrice?.dutyCents > 0) {
      sb += ' 税: ' + getCentPriceTag(fixedPrice?.dutyCents)
    }
    if (!Number.isNaN(fixedPrice?.shippingCents) && fixedPrice?.shippingCents > 0) {
      sb += ' 商家运费: ' + getCentPriceTag(fixedPrice?.shippingCents)
    }
    if (!Number.isNaN(fixedPrice?.processingFeeCents) && fixedPrice?.processingFeeCents > 0) {
      sb += ' 手续费: ' + getCentPriceTag(fixedPrice?.processingFeeCents)
    }
    sb += ')'
    return sb
  }

  const getExtras = (product: any): { [key: string]: any } | null => {
    if (!Array.isArray(matches)) return null
    const extras = {}
    const m = matches.find(m => m.productId === product.id)
    if (m) {
      extras['score'] = m.score
    }
    if (product.fixedPriceCC) {
      extras['CC到手价'] = getFinalPrice(product.fixedPriceCC.fixedPrice, product.fixedPriceCC.explanation)
    }
    if (product.fixedPriceBC) {
      extras['BC到手价'] = getFinalPrice(product.fixedPriceBC.fixedPrice, product.fixedPriceBC.explanation)
    }
    return extras
  }

  const draggerProps = {
    name: 'file',
    customRequest: uploadReq,
    maxCount: 1,
    accept: 'image/*,.png,.jpg,.jpeg',
    onChange(info) {
      const { status } = info.file
      if (status === 'done') {
        message.success(`${info.file.name} image uploaded successfully.`)
        const res = info.file.response
        if (!res) return
        if (res.region) {
          setRegions(res.region.split(',').map(n => +n))
        }
        if (Array.isArray(res.matches)) {
          setMatches(res.matches)
          setCurrentFile(info.file)
          setTotal(res.matches.length)
        }
      } else if (status === 'error') {
        // console.error(info)
        if (info.file.error) {
          showError('image upload failed.', info.file.error)
        } else {
          message.error(`${info.file.name} image upload failed.`)
        }
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  const ImageDrag = (
    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', marginBottom: isMobile ? '0' : '30px' }}>
      <div style={{ flex: 1 }}>
        <Dragger {...draggerProps} style={{ minWidth: '300px' }}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag image file to upload</p>
          <p className="ant-upload-hint">
            Support for jpg/png image only.
          </p>
        </Dragger>
      </div>
      <div style={{ marginLeft: currentFile ? '15px' : 0, overflowX: 'scroll', minWidth: '300px' }}>
        {currentFile ? <SimpleImageEditor file={currentFile.originFileObj} regions={regions} width={600} /> : null}
      </div>
    </div>
  )

  const changeProductCheck = (checked: boolean, index: number) => {
    let _checkedProduct = [...checkedProduct]
    _checkedProduct[index] = checked
    setCheckedProduct([..._checkedProduct])

    setCheckedAllChange(_checkedProduct.every(checked => { return checked }))
  }

  const checkAllChange = (e: CheckboxChangeEvent) => {
    const allCheck = e.target.checked
    setCheckedAllChange(allCheck)

    if (products?.length) {
      let _setCheckedProduct = new Array(products.length).fill(allCheck);
      setCheckedProduct([..._setCheckedProduct])
    }
  }

  const setNewName = (type: string) => {
    const newName = modifyForm.getFieldValue('ModifiedName');
    if (type !== 'delete' && (!newName || newName.trim() === '')) {
      // newName
      return message.error('请输入商品名')
    }

    let ModifiedProductIds: Array<string> = []
    products.map((item, index) => { if (checkedProduct[index]) { ModifiedProductIds.push(item.id) } })
    // 图片搜索没有测试环境， 使用假数据开发
    // let ModifiedProductIds = ["finishline_9A0168-023", "allsole_11468127"]
    modifyName({
      productIds: ModifiedProductIds,
      nameCN: type === 'delete' ? '' : newName,
      add: type === 'additional'
    })
      .then(res => {
        message.success('修改成功')
      })
      .catch(err => {
        message.error('修改失败')
      })
  }

  const setNewCategory = () => {
    const newCateId = modifyForm.getFieldValue('ModifiedCateId')
    let ModifiedProductIds: Array<string> = []
    products.map((item, index) => { if (checkedProduct[index]) { ModifiedProductIds.push(item.id) } })
    // 图片搜索没有测试环境， 使用假数据开发
    // let ModifiedProductIds = ["finishline_9A0168-023", "allsole_11468127"]
    let successed = 0
    for (let i = 0; i < ModifiedProductIds.length; i++) {
      modifyCate(ModifiedProductIds[i], newCateId)
        .then(res => {
          successed += 1
          if (successed === ModifiedProductIds.length) {
            message.success('修改成功')
          }
        })
        .catch(err => {
          message.error('修改失败')
        })
    }
  }

  useEffect(() => {
    if (id) {
      onSearch()
    }
  }, [])

  useEffect(() => {
    if(!Array.isArray(matches)) return
    const curPageIds = getCurPageIds(matches) || []
    searchProductWithIds(curPageIds)
  }, [page.pageNo, matches])

  const categoryTreeSelection = (value, children) => {
    if (children.length >= 1) {
      return message.error("只能选中三级类目！");
    }
    if (value.length > 1) {
      return message.error("只能选中一个类目！");
    }
    setSelectedCategories(value)
  }

  const changeType = (val) => {
    setPage({
      pageNo: 1,
      pageSize: 20
    })
    setTotal(0)
    setMatches(null)
    setProducts(null)
  }

  const pageChange = (cur) => {
    setPage({
      pageNo: cur,
      pageSize: 20
    })
  }

  return (
    <div>
      <Form name='imagesearch' form={form}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item label="Type" name="type" initialValue={id ? "id" : "image"} style={{ marginRight: '15px' }}>
            <Select style={{ width: 120 }} onChange={changeType}>
              <Option value="image">Image</Option>
              <Option value="id">Product Id</Option>
              <Option value="url">Url</Option>
            </Select>
          </Form.Item>
          <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.type !== curValues.type}>
            {() => {
              switch (form.getFieldValue('type')) {
                case 'image':
                default:
                  return ImageDrag
                case 'id':
                  return (
                    <Form.Item label="Product Id" initialValue={id} name="product_id">
                      <Input allowClear style={{ width: 300 }} />
                    </Form.Item>
                  )
                case 'url':
                  return (
                    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', marginBottom: isMobile ? '0' : '30px' }}>
                      <div style={{ flex: 1 }}>
                        <Form.Item label="Image Url" name="url">
                          <Input allowClear style={{ width: 300 }} />
                        </Form.Item>
                      </div>
                      <div style={{ marginLeft: form.getFieldValue('url') ? '15px' : 0, overflowX: 'scroll', minWidth: '300px' }}>
                        {form.getFieldValue('url') ? <SimpleImageEditor url={form.getFieldValue('url')} regions={regions} width={600} /> : null}
                      </div>
                    </div>
                  )
              }
            }}
          </Form.Item>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item label="Brand" name="brandIds" style={{ marginRight: '15px' }}>
            <BrandSelect mode='multiple' placeholder="Please select brand" />
          </Form.Item>
          <Form.Item label="Merchant" name="merchantIds" style={{ marginRight: '15px' }}>
            <MerchantSelect mode='multiple' placeholder="Please select merchant" />
          </Form.Item>
          <Form.Item label="Category" name="categoryIds" style={{ marginRight: '15px' }}>
            <CategorySelect />
          </Form.Item>
          <Form.Item label="Inc. Sold Out" name="oos" style={{ marginRight: '15px' }}>
            <Switch />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={onSearch}>
              查询
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div style={{ margin: '20px 0' }}>
        <Form name='modifyname' form={modifyForm}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item label="批量修改商品名" name="ModifiedName">
              <Input allowClear style={{ width: 300 }} />
            </Form.Item>
            <Button style={{ marginLeft: 20 }} type="primary" onClick={() => setNewName('cover')}>
              覆盖
            </Button>
            <Button style={{ marginLeft: 20 }} type="primary" onClick={() => setNewName('additional')}>
              追加
            </Button>
            <Button style={{ marginLeft: 20 }} type="primary" danger onClick={() => setNewName('delete')}>
              删除
            </Button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item label="批量修改分类" name="ModifiedCateId" style={{ width: 500, marginRight: '15px' }}>
              <CategoryTreeSelect
                selectedCategories={selectedCategories}
                onChange={categoryTreeSelection}
                deprecateOldCategories={true}
              />
            </Form.Item>
            <Button type="primary" onClick={setNewCategory}>
              保存
            </Button>
          </div>
        </Form>
      </div>

      {products && <Checkbox checked={checkedAll} onChange={checkAllChange}>全选</Checkbox>}

      <div style={{ margin: '20px 0' }}>
        <Row gutter={[12, 12]}>
          {
            products && products.map((p, i) => {
              return (
                <Col span={isMobile ? 24 : 6} key={i}>
                  <div style={{ position: 'relative' }}>
                    <GenericProductItem product={p} extras={getExtras(p)} />
                    <Checkbox style={{ position: 'absolute', top: '10px', left: '10px' }} checked={checkedProduct[i]} onChange={(e: CheckboxChangeEvent) => changeProductCheck?.(e.target.checked, i)}></Checkbox>
                  </div>
                </Col>
              )
            })
          }
          <div className='fixPagenation'><Pagination showSizeChanger={false} current={page.pageNo * 1 || 1} total={total} pageSize={page.pageSize} onChange={pageChange}></Pagination></div>
        </Row>
      </div>
    </div>
  )
}

export default ImageSearch
